import {
    GOOGLE_USER_INFO_START,
    GOOGLE_USER_INFO_SUCCESS,
    GOOGLE_LOGIN_START,
    GOOGLE_LOGIN_SUCCESS,
    GOOGLE_LOGIN_ERROR,
} from '../actions/google-auth';

const initialState = {
    userInfo: null,
    status: {
        error: false,
        pending: false,
        success: false,
        gotAccessToken: false,
    },
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GOOGLE_LOGIN_START:
            return {
                userInfo: null,
                status: {
                    pending: true,
                    error: false,
                    success: false,
                    gotAccessToken: false,
                },
            };
        case GOOGLE_LOGIN_SUCCESS:
            return {
                userInfo: action.payload,
                status: {
                    pending: false,
                    error: false,
                    success: false,
                    gotAccessToken: false,
                },
            };
        case GOOGLE_LOGIN_ERROR:
            return {
                userInfo: null,
                status: {
                    pending: false,
                    error: true,
                    success: false,
                    gotAccessToken: false,
                },
            };
        case GOOGLE_USER_INFO_START:
            return {
                ...state,
                status: {
                    pending: true,
                    error: false,
                    success: false,
                    gotAccessToken: false,
                },
            };
        case GOOGLE_USER_INFO_SUCCESS:
            return {
                userInfo: {
                    ...state.userInfo,
                    ...action.payload,
                },
                status: {
                    pending: false,
                    error: false,
                    success: true,
                    gotAccessToken: true,
                },
            };
        default:
            return state;
    }
}
